import React from 'react';
import { canAccessAdmin } from '../utils/accessControl';
import AccessGate from './AccessGate';

const AdminRoute = ({ children }) => {
  return (
    <AccessGate
      canAccess={canAccessAdmin}
      title="Admin Access Required"
      message="Your account does not have permission to access this admin area."
      actionLabel="Go To Home"
      actionTo="/"
    >
      {children}
    </AccessGate>
  );
};

export default AdminRoute;
